import { mount } from '../boot.js';
import { FxGrid } from './FxGrid.js';

mount(FxGrid);
